module.exports = __webpack_public_path__ + "static/media/aroldo-repousando-esquerda.8e1cc7e2.svg";